import { createSelector } from 'reselect'
import { RootState } from '../types'
import { LoadingStateEnum } from '../../types'

export const getSfBankAccountsLoadingState = (state: RootState): RootState['sfBankAccounts']['loading'] =>
  state.sfBankAccounts.loading

export const sfBankAccountsIsLoading = createSelector(
  getSfBankAccountsLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getSfBankAccountsData = (state: RootState): RootState['sfBankAccounts']['data'] =>
  state.sfBankAccounts.data

export const getSfBankAccountsError = (state: RootState): RootState['sfBankAccounts']['error'] =>
  state.sfBankAccounts.error

export const getAssignedAccountsLoadingState = (
  state: RootState,
): RootState['sfBankAccounts']['assignedUserAccounts']['loading'] => state.sfBankAccounts.assignedUserAccounts.loading

export const assignedAccountsIsLoading = createSelector(
  getAssignedAccountsLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getAssignedAccountIdsByUser = (
  state: RootState,
): RootState['sfBankAccounts']['assignedUserAccounts']['assignedIds'] =>
  state.sfBankAccounts.assignedUserAccounts.assignedIds

export const getAssignedAccountsByUser = (
  state: RootState,
): RootState['sfBankAccounts']['assignedUserAccounts']['data'] => state.sfBankAccounts.assignedUserAccounts.data
